module.exports = __webpack_public_path__ + "static/media/cancelled-game.b7312dbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cancelled-game.png
// module id = 247
// module chunks = 0